import { SxProps, Theme } from '@mui/material';
import { StyledTheme } from '../../../styles/styleTheme';

const BORDER = '1px solid #E0E0E0';

export const triggerButtonStyles: SxProps<Theme> = {
  background: StyledTheme.grayDark,
  '&:hover': { backgroundColor: '#1E83A0' },
  whiteSpace: 'nowrap',
};

export const modalStyles: SxProps<Theme> = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'min(900px, 92vw)',
  height: 'min(85vh, 720px)',
  backgroundColor: StyledTheme.white,
  borderRadius: '8px',
  boxShadow: 24,
  outline: 'none',
  overflow: 'hidden',
};

export const headerStyles: SxProps<Theme> = { px: 2, py: 1.25, borderBottom: BORDER };

export const titleIconStyles: SxProps<Theme> = { color: StyledTheme.tealDark };

export const tabsStyles: SxProps<Theme> = { px: 2, borderBottom: BORDER, minHeight: 42 };

export const tabStyles: SxProps<Theme> = {
  textTransform: 'none',
  minHeight: 42,
  '&.Mui-selected': { color: StyledTheme.tealDark },
};

export const tabIndicatorStyle = { backgroundColor: StyledTheme.tealDark };

export const footerStyles: SxProps<Theme> = { px: 2, py: 0.75, borderTop: BORDER };

export const stageStyles = (canZoom: boolean, isZoomed: boolean): SxProps<Theme> => ({
  flex: 1,
  display: 'flex',
  backgroundColor: '#EBEBEF',
  overflow: 'auto',
  cursor: canZoom ? (isZoomed ? 'zoom-out' : 'zoom-in') : 'default',
  p: 2,
});

export const imageStyles = (isZoomed: boolean, zoom: number): SxProps<Theme> => ({
  margin: 'auto',
  flexShrink: 0,
  transition: 'width 0.15s ease',
  ...(isZoomed
    ? { width: `${zoom * 100}%`, height: 'auto', maxWidth: 'none' }
    : { maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }),
});
